import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import { getMetaByCountry } from "../../metaConfig";

function Disclaimer() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const [isMetaTitle, setMetaTitle] = useState("");
  useEffect(() => {
    const { title } = getMetaByCountry(countryCode);
    setMetaTitle(title);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={"Disclaimer"} metaTitle={isMetaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h3 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>{t("Disclaimer")}</h3>

                <p>
                  The information provided by {Host?.companyName} ("we," "us," or "our") on {window.location.hostname}{" "}
                  (the "Site") is for general informational and educational purposes only. All information on the Site
                  is provided in good faith; however, we make no representation or warranty of any kind, express or
                  implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any
                  information on the Site.
                </p>

                <h4>1. No Professional Advice</h4>
                <p>
                  The Site cannot and does not contain legal, medical, financial, or other professional advice. Any
                  information provided is for general informational purposes only and should not be relied upon as a
                  substitute for professional advice. You should always seek the advice of qualified professionals
                  before taking any action based on information obtained from the Site.
                </p>

                <h4>2. External Links Disclaimer</h4>
                <p>
                  The Site may contain links to third-party websites or content belonging to or originating from third
                  parties. Such external links are provided for convenience only and are not investigated, monitored, or
                  checked for accuracy or reliability by us. We do not warrant, endorse, guarantee, or assume
                  responsibility for the accuracy or reliability of any information offered by third-party websites
                  linked through the Site.
                </p>

                <h4>3. Product & Service Disclaimer</h4>
                <p>
                  We make every effort to display and describe our products and services accurately. However, we do not
                  guarantee that product descriptions, images, pricing, or other content on the Site are complete,
                  reliable, current, or error-free. All products and services are provided "as is" and "as available"
                  without warranties of any kind.
                </p>

                <h4>4. Limitation of Liability</h4>
                <p>
                  Under no circumstance shall we be held liable for any loss or damage of any kind incurred as a result
                  of the use of the Site or reliance on any information provided on the Site. Your use of the Site and
                  your reliance on any information is solely at your own risk.
                </p>

                <h4>5. Updates</h4>
                <p>
                  We reserve the right to update, change, or remove content on the Site at any time without prior
                  notice. It is your responsibility to review this Disclaimer periodically for any updates.
                </p>

                <h4>Contact Us</h4>
                <p>If you have questions about this Disclaimer, please contact us at:</p>
                <div style={{ fontSize: "14px" }}>
                  <strong>Trade Name: {Host?.domainName2}</strong>
                  <br />
                  <strong>Trade License: {Host?.companyName}</strong>
                  <br />
                  <strong>License Number: {Host?.licenseNumber}</strong>
                </div>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                </p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Disclaimer;
